module.exports = __webpack_public_path__ + "media/images/Logo-4fe288c63a092ec242c73ceabc908c50.svg";